import {
  editManualCharge,
  EditManualchargeReturn,
  deleteLedgerLink,
  DeleteLinkReturn,
  deleteOrderLedgerAssociation,
  DeleteOrderLedgerAssociationReturn,
} from 'graphql/ledger/mutations';
import { updateCashToClose, UpdateCashToCloseReturn } from 'graphql/cash-to-close/mutations';
import { deleteMortgage, DeleteMortgageMutationReturn } from 'views/orders/mortgage-payoffs/services/mutations';

import { createMutationHook } from 'hooks/factories/createMutationHook';

type GraphQLErrorResponse = {
  response: {
    errors: {
      message: string;
    }[];
  };
};

export const useUpdateEntry = createMutationHook<EditManualchargeReturn>(editManualCharge);
export const useDeleteOrderLedgerLink = createMutationHook<DeleteLinkReturn>(deleteLedgerLink);
export const useDeleteOrderLedgerAssociation = createMutationHook<
  DeleteOrderLedgerAssociationReturn,
  any,
  GraphQLErrorResponse
>(deleteOrderLedgerAssociation);
export const useUpdateCashToClose = createMutationHook<UpdateCashToCloseReturn>(updateCashToClose);
export const useDeletePayoff = createMutationHook<DeleteMortgageMutationReturn>(deleteMortgage);
